module.exports = __webpack_public_path__ + "static/009.thumb-60c5e5dd772a3260e72d08e98b22ebb4.jpg";